import CommonUiModel from "../common/commonUiModel";

const ScopeType = new CommonUiModel({
    title: "ScopeType",
    customAddText: "Add Scope Type",
    linkColumn: "Name",
    formTitle: 'Scope Type',
    gridTitle: 'Scope Type',
    columns: [
        { field: 'ScopeTypeId', gridLabel: "ScopeType Id", type: 'number', width: 120, label: null },
        { field: 'Name', label: 'Scope Type Name', required: true, max: 100 },
        { field: 'Description', label: 'Description', multiline: true },
        { field: 'Notes', label: 'Notes', multiline: true },
        { field: "ScopeTypeAlias", label: "Alias", type: "chipInput", required: false, lookup: 'ScopeTypeAlias', width: 300, hasDefault: true, disabled: ({ isAdd }) => isAdd, dataFormat: "array" },
        { field: "Active", label: 'Active', type: 'boolean', defaultValue: true, width: 80, sortable: false }
    ]
});

export default ScopeType;